import type {AxiosRequestConfig, AxiosResponse} from "axios";
import type {ApiRequestDs} from "./request";
import type {ApiResponseDs} from "./response";

export type * from './request';
export type  * from './response';


export type RequestInterceptor = {
    onFulfilled?: (value: AxiosRequestConfig) => AxiosRequestConfig | Promise<AxiosRequestConfig>,
    onRejected?: (error: any) => any,
};
export type ResponseInterceptor = {
    onFulfilled?: (value: AxiosResponse) => AxiosResponse | Promise<AxiosResponse>,
    onRejected?: (error: any) => any
};

export interface ApiInterceptorRecord<Interceptor> {
    id: string,
    interceptor: Interceptor;
}

export interface ApiInterceptors {
    request: Array<ApiInterceptorRecord<RequestInterceptor>>,
    response: Array<ApiInterceptorRecord<ResponseInterceptor>>,
}

export interface ClearInterceptorsArg {
    request?: boolean,
    response?: boolean,
}

/**
 * Different values of api call methods.
 */
export enum ApiMethods {
    get = 'GET',
    post = 'POST',
    put = 'PUT',
    delete = 'DELETE',
    patch = 'PATCH',
}

export interface ApiExecutorEffect {
    id: string,
    effect: (request: ApiRequestDs, response: ApiResponseDs) => (void | Promise<void>),
}


export interface IApiExecutor {

    /**
     * Injects api interceptors to the axios instance used in this interface.
     * @param interceptors  the interceptors to be injected.
     */
    injectInterceptors(interceptors: Partial<ApiInterceptors>): void;

    /**
     * Injects the given effects to the executor.
     * @param effects       The effects to be injected.
     */
    injectEffects(effects: Array<ApiExecutorEffect>): void;

    /**
     * Clears all the effects that are injected.
     */
    clearEffects(): void;

    /**
     * Clears all the interceptors that are injected.
     * @param arg           The arguments to clear the interceptors.
     */
    clearInterceptors(arg?: { request?: boolean, response?: boolean }): void;

    /**
     * Executes the api call with the given args and then parses the response.
     * @param request      The request that will be executed.
     */
    execute(request: ApiRequestDs): Promise<ApiResponseDs>;
}
